// Періоди дашборда (за київським часом): календарні місяць, квартал, рік
const kyivToday = () => new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Kyiv" }).format(new Date());
const iso = (y, m, d) => new Date(Date.UTC(y, m, d)).toISOString().slice(0, 10);
const MONTHS = ["січень", "лютий", "березень", "квітень", "травень", "червень", "липень", "серпень", "вересень", "жовтень", "листопад", "грудень"];

export const PERIODS = [
  { key: "month", label: "Поточний місяць" },
  { key: "prev-month", label: "Минулий місяць" },
  { key: "quarter", label: "Поточний квартал" },
  { key: "prev-quarter", label: "Минулий квартал" },
  { key: "year", label: "Поточний рік" },
  { key: "prev-year", label: "Минулий рік" },
];
export const DEFAULT_PERIOD = "prev-month";

export function periodRange(key, today = kyivToday()) {
  const [y, m] = today.split("-").map(Number);
  const mi = m - 1, q = Math.floor(mi / 3) * 3;
  switch (key) {
    case "month": return { from: iso(y, mi, 1), to: iso(y, mi + 1, 0), label: `${MONTHS[mi]} ${y}` };
    case "prev-month": { const d = new Date(Date.UTC(y, mi - 1, 1)); const py = d.getUTCFullYear(), pm = d.getUTCMonth();
      return { from: iso(py, pm, 1), to: iso(py, pm + 1, 0), label: `${MONTHS[pm]} ${py}` }; }
    case "quarter": return { from: iso(y, q, 1), to: iso(y, q + 3, 0), label: `${q / 3 + 1} квартал ${y}` };
    case "prev-quarter": { const d = new Date(Date.UTC(y, q - 3, 1)); const py = d.getUTCFullYear(), pq = d.getUTCMonth();
      return { from: iso(py, pq, 1), to: iso(py, pq + 3, 0), label: `${pq / 3 + 1} квартал ${py}` }; }
    case "year": return { from: iso(y, 0, 1), to: iso(y, 11, 31), label: `${y} рік` };
    case "prev-year": return { from: iso(y - 1, 0, 1), to: iso(y - 1, 11, 31), label: `${y - 1} рік` };
    default: return periodRange(DEFAULT_PERIOD, today);
  }
}

export const monthShort = (ym) => {
  const [y, m] = ym.split("-");
  return `${["січ", "лют", "бер", "кві", "тра", "чер", "лип", "сер", "вер", "жов", "лис", "гру"][Number(m) - 1]} ${y.slice(2)}`;
};
